import cls from 'classnames';
import { ReactNode } from 'react';

import useStyles from './styles';

interface ILayoutForTextApps {
  className?: string;
  stickyInputChild: ReactNode;
  sidebarChild: ReactNode;
  listingChild: ReactNode;
  listingBarChild: ReactNode;
  children: ReactNode;
  preHeadlineChild?: ReactNode;
  stickyOffset?: number;
  adChild?: ReactNode | null;
}

function LayoutForTextApps({
  children,
  className,
  sidebarChild,
  stickyOffset,
  listingChild,
  listingBarChild,
  stickyInputChild,
  preHeadlineChild,
  adChild = null,
}: ILayoutForTextApps) {
  const styles = useStyles();

  return (
    <div className={cls(className)}>
      <div className={cls(styles.mainContainer, 'lfta-main-container')}>
        <div className={styles.mainContainerContent}>
          {stickyInputChild}

          <div className={styles.mainContent}>
            <div className={styles.mainContentSidebar}>
              <div className={styles.mainContentSidebarSticky}>{sidebarChild}</div>
            </div>

            <div className={styles.mainContentResults}>
              <div className={styles.mainContentBar} style={{ top: stickyOffset }}>
                {preHeadlineChild}
                <div className={styles.mainContentBarContent}>{listingBarChild}</div>
              </div>

              {listingChild}
            </div>
          </div>
        </div>

        <div>{adChild}</div>
      </div>
      <div className={cls(styles.landing, 'lfta-landing')}>{children}</div>
    </div>
  );
}

export default LayoutForTextApps;
